<template>
  <div class="row justify-content-center">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="col-12 col-lg-7" v-if="metchantdata">
      <b-card no-body>
        <b-tabs
          card
          lazy
          justified
          active-nav-item-class="font-weight-bold text-uppercase text-primary"
        >
          <b-tab title="Card Payment" active>
            <div class="row justify-content-center text-center">
              <div class="col-6">
                <h4 class="font-size">Amount:</h4>
              </div>
              <div class="col-6">
                <h4 class="font-size">
                  $
                  {{
                    metchantdata.merchant_payment_detail.cart_amount.toFixed(2)
                  }}
                </h4>
              </div>
            </div>
            <div class="row justify-content-center text-center">
              <div class="col-6">
                <h4 class="font-size">Tax/Vat:</h4>
              </div>
              <div class="col-6">
                <h4 class="font-size">
                  $
                  {{
                    metchantdata.merchant_payment_detail.tax_amount.toFixed(2)
                  }}
                </h4>
              </div>
            </div>
            <div class="row justify-content-center text-center">
              <div class="col-6">
                <h4 class="font-size">Total Amount:</h4>
              </div>
              <div class="col-6">
                <h4 class="font-size">
                  $
                  {{
                    (
                      parseFloat(
                        metchantdata.merchant_payment_detail.cart_amount
                      ) +
                      parseFloat(
                        metchantdata.merchant_payment_detail.tax_amount
                      )
                    ).toFixed(2)
                  }}
                </h4>
              </div>
            </div>
            <form class="card-payment-form mt-0" method="POST" action>
              <div class="row pt-2  align-items-center">
                <div class="col-12 col-lg-5">
                  <div>
                    <input
                      type="text"
                      name="name"
                      v-model="form.cardholder_name"
                      required
                      class="mt-1"
                    />
                    <label
                      alt="Card Holder Name"
                      placeholder="Card Holder Name"
                    ></label>
                  </div>
                </div>
                <div class="col-12 col-lg-7">
                  <div class="card-number m-0 position-relative">
                    <input
                      type="text"
                      name="cardnumber"
                      v-model="form.cardNumber"
                      @keypress="onlyNumber"
                      @keyup="detectCardType"
                      required
                    />
                    <label
                      alt="Card Number"
                      placeholder="1023-XXX-12243-XXXXX"
                    ></label>
                    <div class="card-image position-absolute">
                      <img
                        v-if="cardType === 'True'"
                        src="@/assets/payment/sample.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'DISCOVER'"
                        src="@/assets/payment/discover.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'AMEX'"
                        src="@/assets/payment/amex.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'DINERS'"
                        src="@/assets/payment/dinersclub.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'JCB'"
                        src="@/assets/payment/jcb.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'UPOP'"
                        src="@/assets/payment/upop.png"
                        alt
                      />
                      <img
                        v-if="cardType === 'VISA'"
                        src="@/assets/payment/visa.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'MASTER'"
                        src="@/assets/payment/master-card.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'VISA-MASTER'"
                        src="@/assets/payment/master-card.svg"
                        alt
                      />
                      <img
                        v-if="cardType === 'BCGLOBAL'"
                        src="@/assets/payment/bcglobal.svg"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row align-items-center">
                <div class="col-12 col-lg-4 my-2">
                  <div class="floating-label position-relative">
                    <div class="select">
                      <select v-model="form.year" required>
                        <option value disabled selected>Year</option>
                        <option
                          v-for="(n, $index) in 21"
                          v-bind:value="$index + minCardYear"
                          v-bind:key="n"
                          v-html="$index + minCardYear"
                        ></option>
                      </select>
                    </div>
                    <span class="position-absolute">Expiry Year</span>
                  </div>
                </div>
                <div class="col-12 col-lg-4 my-2">
                  <div class="floating-label position-relative">
                    <div class="select">
                      <select v-model="form.month" required>
                        <option value disabled selected>Month</option>
                        <option
                          :value="n < 10 ? '0' + n : n"
                          v-for="n in 12"
                          v-bind:key="n"
                          v-html="n < 10 ? '0' + n : n"
                        ></option>
                      </select>
                    </div>
                    <span class="position-absolute">Expiry Month</span>
                  </div>
                </div>
                <div class="col-12 col-lg-3 my-2">
                  <input
                    :maxlength="cvvLength"
                    type="text"
                    name="cvv"
                    v-model="form.cardCvv"
                    :placeholder="cvvPlaceholder"
                    @keypress="onlyNumber"
                  />
                  <label alt="CVV" placeholder="CVV"></label>
                </div>
                <div class="col-1 d-none d-lg-block">
                  <span
                    class="material-icons"
                    v-b-popover.hover.right="
                      'The Card Verification Code, or CVC*, is an extra code printed on your debit or credit card. With American Express the CVC appears as a separate 4-digit code printed on the front of your card. With all other cards (Visa, MasterCard, bank cards etc.) it is the final three digits of the number printed on the signature strip on the reverse of your card. As the CVC is not embossed (like the card number), the CVC is not printed on any receipts, hence it is not likely to be known by anyone other than the actual card owner.We ask you to fill out the CVC here to verify beyond any doubt that you actually hold the card you are using for this transaction, and to avoid anyone other than you from shopping with your card number. All information you submit is transferred over secure SSL connections.The name of this code differs per card company. You may also know it as the Card Verification Value (CVV), the Card Security Code or the Personal Security Code. All names cover the same type of information.'
                    "
                    title="CVV"
                  >
                    info
                  </span>
                </div>
              </div>

              <div class="row mb-1">
                <div class="col-12">
                  <b-button @click="validateForm" variant="amej-button"
                    >Submit</b-button
                  >
                </div>
              </div>
              <span>Your card data security is our primary priority.</span>
            </form>
          </b-tab>
          <b-tab title="Wallet Payment">
            <form class="wallet-payment-form">
              <div class="row justify-content-center text-center">
                <div class="col-6">
                  <h4 class="font-size">Amount:</h4>
                </div>
                <div class="col-6">
                  <h4 class="font-size">
                    $
                    {{
                      metchantdata.merchant_payment_detail.cart_amount.toFixed(
                        2
                      )
                    }}
                  </h4>
                </div>
              </div>
              <div class="row justify-content-center text-center">
                <div class="col-6">
                  <h4 class="font-size">Tax/Vat:</h4>
                </div>
                <div class="col-6">
                  <h4 class="font-size">
                    $
                    {{
                      metchantdata.merchant_payment_detail.tax_amount.toFixed(2)
                    }}
                  </h4>
                </div>
              </div>
              <div class="row justify-content-center text-center mb-3">
                <div class="col-6">
                  <h4 class="font-size">Total Amount:</h4>
                </div>
                <div class="col-6">
                  <h4 class="font-size">
                    $
                    {{
                      (
                        parseFloat(
                          metchantdata.merchant_payment_detail.cart_amount
                        ) +
                        parseFloat(
                          metchantdata.merchant_payment_detail.tax_amount
                        )
                      ).toFixed(2)
                    }}
                  </h4>
                </div>
              </div>
              <div class="row justify-content-center text-center">
                <div class="col-12">
                  <h4 class="mt-2 font-size">Please Login to Continue</h4>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 col-lg-6 mt-3">
                  <!-- <router-link v-if="isAuthenticated" :to="{ name: 'payment-confirm', params: {transactionid: transactionid} }">
                    <b-button variant="amej-button">GoTo Payment</b-button>
                  </router-link> -->
                  <router-link
                    :to="{
                      name: 'payment-login-form',
                      params: { transactionid: transactionid },
                    }"
                  >
                    <b-button variant="amej-button">Login</b-button>
                  </router-link>
                </div>
                <div class="col-12 col-lg-6 mt-3">
                  <b-button variant="amej-button" @click="cancelPayment"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </form>
          </b-tab>
        </b-tabs>
        <div class="row justify-content-center py-1">
          <div class="col-2">
            <div class="payment-logo">
              <a href="/">
                <img src="@/assets/amej-pay.png" alt="Amejpay" />
              </a>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <b-toast
      id="error"
      variant="warning"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Error!!</strong>
      </div>
      <div v-if="errors.cardholder_name">
        <p>{{ errors.cardholder_name }}</p>
      </div>
      <div v-if="errors.cardNumber">
        <p>{{ errors.cardNumber }}</p>
      </div>
      <div v-if="errors.invalidNumber">
        <p>{{ errors.invalidNumber }}</p>
      </div>
      <div v-if="errors.year">
        <p>{{ errors.year }}</p>
      </div>
      <div v-if="errors.month">
        <p>{{ errors.month }}</p>
      </div>
      <div v-if="errors.cardCvv">
        <p>{{ errors.cardCvv }}</p>
      </div>
      <div v-if="errors.cardError">
        <p>{{ errors.cardError }}</p>
      </div>
    </b-toast>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState, mapActions, mapMutations } from "vuex";
const axios = require("axios");

export default {
  props: {
    metchantdata: Object,
    transactionid: String,
  },
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      minCardYear: new Date().getFullYear(),
      isAuthenticated: false,
      form: {
        cardholderName: "",
        cardNumber: "",
        year: "",
        month: "",
        cardCvv: "",
      },
      successUrlValue: "",
      failUrlValue: "",
      submitted: false,
      cardType: "True",
      cvvPlaceholder: "CVV",
      cvvLength: 3,
      regxVisa: /^4[0-9]{12}(?:[0-9]{3})?$/,
      regxMaster: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      regxAmex: /^3[47][0-9]{13}$/,
      regexDiners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      regexJcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      regexLine: "",
      regexDiscover: /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
      regexUpop: /^(62[0-9]{14,17})$/,
      regexVisaMaster: /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$/,
      regexBCGlobal: /^(6541|6556)[0-9]{12}$/,
      regexCarteBlanche: /^389[0-9]{11}$/,
      regexInstaPayment: /^63[7-9][0-9]{13}$/,
      regexKoreanLocal: /^9[0-9]{15}$/,
      regexLaserCard: /^(6304|6706|6709|6771)[0-9]{12,15}$/,
      regexMaestro: /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/,
      regexSoloCard: /^(6334|6767)[0-9]{12}|(6334|6767)[0-9]{14}|(6334|6767)[0-9]{15}$/,
      regexSwitchCard: /^(4903|4905|4911|4936|6333|6759)[0-9]{12}|(4903|4905|4911|4936|6333|6759)[0-9]{14}|(4903|4905|4911|4936|6333|6759)[0-9]{15}|564182[0-9]{10}|564182[0-9]{12}|564182[0-9]{13}|633110[0-9]{10}|633110[0-9]{12}|633110[0-9]{13}$/,
      regexCvv: /^[0-9]{3, 4}$/,
      // validations: {
      //   form: {
      //     cardholder_number: { required },
      //     // cardExpMonth: { required },
      //     // cardExpYear: { required },
      //     // cardCvv: { required },
      //     // cardHolderName: { required },
      //   }
      // },
    };
  },
  created() {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("token") != "" &&
      localStorage.getItem("token").length > 50
    ) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
  },
  computed: {
    ...mapState(["successmessage", "errormessage", "message"]),
  },
  methods: {
    ...mapMutations(["setToken"]),
    rndStr(len) {
      let text = "";
      let chars = "1234567890abcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * 35));
      }
      return text;
    },
    detectCardType() {
      let cardTypeNumber = "true";
      let clearCardNumber = this.form.cardNumber.replace(/\s/g, "");
      if (this.regxVisa.test(clearCardNumber)) {
        this.cardType = "VISA";
      } else if (this.regxMaster.test(clearCardNumber)) {
        this.cardType = "MASTER";
      } else if (this.regxAmex.test(clearCardNumber)) {
        this.cardType = "AMEX";
        this.cvvLength = 4;
        this.cvvPlaceholder = "XXXX";
      } else if (this.regexDiners.test(clearCardNumber)) {
        this.cardType = "DINERS";
      } else if (this.regexJcb.test(clearCardNumber)) {
        this.cardType = "JCB";
      } else if (this.regexDiscover.test(clearCardNumber)) {
        this.cardType = "DISCOVER";
      } else if (this.regexUpop.test(clearCardNumber)) {
        this.cardType = "UPOP";
      } else if (this.regexVisaMaster.test(clearCardNumber)) {
        this.cardType = "VISAMASTER";
      } else if (this.regexBCGlobal.test(clearCardNumber)) {
        this.cardType = "BCGLOBAL";
      } else {
        this.cardType = "True";
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    validateForm(e) {
      e.preventDefault();
      this.isLoading = false;
      let clearCardNumber = this.form.cardNumber.replace(/\s/g, "");
      this.errors = [];
      if (
        this.form.cardholder_name == "" ||
        this.form.cardholder_name == null
      ) {
        this.errors["cardholder_name"] = "Card Holder Name is required";
        this.$bvToast.show("error");
      } else if (clearCardNumber == "" || clearCardNumber == null) {
        this.errors["cardNumber"] = "Card Number is required";
        this.$bvToast.show("error");
      } else if (
        !(
          this.cardType == "VISA" ||
          this.cardType == "MASTER" ||
          this.cardType == "AMEX" ||
          this.cardType == "DINERS" ||
          this.cardType == "JCB" ||
          this.cardType == "DISCOVER" ||
          this.cardType == "UPOP" ||
          this.cardType == "VISAMASTER" ||
          this.cardType == "BCGLOBAL"
        )
      ) {
        this.errors["invalidNumber"] = "Enter valid card number.";
        this.$bvToast.show("error");
      } else if (this.form.year == "" || this.form.year == null) {
        this.errors["year"] = "Select expiry year";
        this.$bvToast.show("error");
      } else if (this.form.month == "" || this.form.month == null) {
        this.errors["month"] = "Select expiry month";
        this.$bvToast.show("error");
      } else if (this.form.cardCvv == "" || this.form.cardCvv == null) {
        this.errors["cardCvv"] = "CVV is required";
        this.$bvToast.show("error");
      } else {
        //
        if (this.metchantdata) {
          this.isLoading = true;
          this.successUrlValue =
            this.metchantdata.merchant_payment_detail.success_url +
            "?status=success&transaction_key=" +
            this.metchantdata.merchant_payment_detail.transaction_key +
            "&transaction_id=" +
            this.transactionid;
          this.failUrlValue =
            this.metchantdata.merchant_payment_detail.failure_url +
            "?status=fail&transaction_key=" +
            this.metchantdata.merchant_payment_detail.transaction_key +
            "&transaction_id=" +
            this.transactionid;

          let totalAmount =
            parseFloat(this.metchantdata.merchant_payment_detail.cart_amount) +
            parseFloat(this.metchantdata.merchant_payment_detail.tax_amount);
          let merchantCardForm = new FormData();
          merchantCardForm.append(
            "merchant_public_key",
            this.metchantdata.merchant_account_detail.merchant_public_key
          );
          merchantCardForm.append(
            "transaction_id",
            this.$route.params.transactionid
          );
          merchantCardForm.append("amount", totalAmount);
          merchantCardForm.append(
            "card_number",
            this.form.cardNumber.replace(/\s/g, "")
          );
          merchantCardForm.append("exp_month", this.form.month);
          merchantCardForm.append("exp_year", this.form.year);
          merchantCardForm.append("cvc", this.form.cardCvv.replace(/\s/g, ""));
          merchantCardForm.append("card_type", this.cardType);

          // for (var pair of merchantCardForm.entries()) {
          //     // eslint-disable-next-line no-console
          //     console.log(pair[0]+ ', ' + pair[1]);
          // }

          axios
            .post("merchantcardpayment", merchantCardForm)
            .then((response) => {
              if (response.status == 200) {
                this.isLoading = false;
                // do the process for return response to user
                window.localStorage.setItem("token", "");
                this.setToken("");

                window.open(this.successUrlValue, "_self");
              } else {
                this.errors["cardError"] = "Card Payment Failed.";
                this.$bvToast.show("error");
                // setTimeout(() => {
                //   location.reload();
                // }, 500);
              }
            })
            .catch((error) => {
              if (error) {
                this.isLoading = false;
                this.errors["cardError"] = "Invalid Card Detail.";
                this.$bvToast.show("error");
                // setTimeout(() => {
                //   location.reload();
                // }, 500);
              }
            });
        } else {
          // redirect to failure url
        }
      }
    },
    cancelPayment() {
      window.localStorage.setItem("token", "");
      this.setToken("");
      if (this.metchantdata) {
        let reloadUrl =
          this.metchantdata.merchant_payment_detail.failure_url +
          "?status=failtransaction_key=" +
          this.transactionid;
        window.open(reloadUrl, "_self");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.error-message {
  color: red;
}
</style>
